import { render, staticRenderFns } from "./verificationLogin.vue?vue&type=template&id=a8930622"
import script from "./verificationLogin.vue?vue&type=script&lang=js"
export * from "./verificationLogin.vue?vue&type=script&lang=js"
import style0 from "./verificationLogin.vue?vue&type=style&index=0&id=a8930622&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports